import axios from 'axios';
import { errorHelper, messageHelper } from '../helper.js';
import {
  PROPOSAL_DETAIL_URL,
  GET_USER_ID_URL,
  SAMPLETYPES_URL,
  PROPOSAL_VARIABLE_LIST_URL,
} from '../../../vars';

/**
 * @namespace Proposal
 * @description Жизненный цикл заявки (Page: /proposal/:id)
 */
export default {
  state: {
    fullProposal: null,
    currentProposalId: null,
    showProposalCard: false,
    ProposalCallId: null,
    needReloadCloseProposal: false,
    needReloadList: false,
    needReloadCalendar: false,

    userIdTeam: null,
    sample_types: [],
  },
  mutations: {
    UPDATE_FULL_PROPOSAL(state, data) {
      state.fullProposal = data;
    },

    SHOW_PROPOSAL_CARD(state, data){
      state.currentProposalId = data['proposal_id'];
      state.ProposalCallId = data['call_id'];
      state.showProposalCard = true;
      state.needReloadCloseProposal = false;
      state.needReloadList = false;
      state.needReloadCalendar = false;
            
    },

    UPDATE_PROPOSAL_CALENDAR_MUTATION(state, data){
      state.needReloadCalendar = data;
    },

    CLOSE_PROPOSAL_CARD_MUTATION(state, data){
      state.showProposalCard = false;
      if(data['need_reload_parent'])
        state.needReloadCloseProposal = state.ProposalCallId;
      state.needReloadList = data['need_reload_list'];
      state.needReloadCalendar = data['need_reload_calendar'];

      // console.log('CLOSE_PROPOSAL_CARD need update:', data)
    },

    UPDATE_USER_ID_TEAM(state, data) {
      state.userIdTeam = data;
    },
    UPDATE_SAMPLETYPES(state, data) {
      // console.log('UPDATE_SAMPLETYPES', data)
      state.sample_types = data;
    },
  },

  actions: {
    UPDATE_PROPOSAL_CALENDAR(ctx, data){
      ctx.commit('UPDATE_CURRENT_CALENDAR', true);
      ctx.commit('UPDATE_PROPOSAL_CALENDAR_MUTATION', data);
    },

    CLOSE_PROPOSAL_CARD(ctx, data){
      if(data['need_reload_calendar']){
        ctx.commit('UPDATE_CURRENT_CALENDAR', true);
      }
      ctx.commit('CLOSE_PROPOSAL_CARD_MUTATION', data);

    },

        /**
     * Получает детальную информацию и записывает
     * @param {Object} ctx
     * @param {String|Number} id Идентификатор
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async GET_FULL_PROPOSAL(ctx, id) {
      try {
        const res = await axios.get(`${PROPOSAL_DETAIL_URL}?id=${id}&expand=[%22all%22]`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });

        await ctx.commit('UPDATE_FULL_PROPOSAL', res.data);

        return res.data;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' GET_FULL_PROPOSAL');
        throw e;
      }
    },



    async PROPOSAL_VARIABLE_LIST(ctx, data) {
      try {
        const res = await axios.post(PROPOSAL_VARIABLE_LIST_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data;
      } catch (e) {
        console.log('PROPOSAL_VARIABLE_LIST error', e)
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e;
      }
    },

    /**
     * Получает и записывает данные
     * @param {Object} ctx
     * @param {String} data Email
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Proposal
     */
    async GET_USER_ID_TEAM(ctx, data) {
      try {
        const res = await axios.get(`${GET_USER_ID_URL}?email=${data}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });

        await ctx.commit('UPDATE_USER_ID_TEAM', {
          id: res.data.profile_id,
          individual: { first_name: res.data.first_name, last_name: res.data.last_name },
        });
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('GET_USER_ID_TEAM', e.response);
        throw e;
      }
    },

    async LOAD_SAMPLETYPES(ctx) {
      try {
        await axios.get(SAMPLETYPES_URL, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        })
          .then((res) => ctx.commit('UPDATE_SAMPLETYPES', res.data))
          .catch((e) => {
            errorHelper(e);
            messageHelper('', 'error', 6000, e);
          });

      } catch (ex) {
        console.log('ex store---> ', ex);
        messageHelper('', 'error', 6000, ex);
      }    
    },
  },
  getters: {
    GETTERS_NEED_RELOAD_CLOSE_PROPOSAL(state){
      return state.needReloadCloseProposal;
    },

    GETTERS_NEED_RELOAD_PROPOSAL_LIST(state){
      return state.needReloadList;
    },

    GETTERS_NEED_RELOAD_CALENDAR(state){
      return state.needReloadCalendar;
    },

    GETTERS_CLOSE_PROPOSAL_CALL_ID(state){
      return state.ProposalCallId;
    },

    GETTERS_CURRENT_PROPOSAL_ID(state){
      return state.currentProposalId;
    },
    GETTERS_SHOW_PROPOSAL_CARD(state){
      return state.showProposalCard;
    },

    GETTERS_USER_ID_TEAM(state) {
      return state.userIdTeam;
    },
    GETTERS_SAMPLETYPES(state) {
      return state.sample_types;
    },
  },
};
